import { IContentSpace } from '../../interfaces/IComponents';
import { EpCard } from '../EpCard';
import { EpContentSpace } from '../EpContentSpace';

interface IEpEmptyState extends IContentSpace {
  cardHeight?: number | 'self' | 'auto';
  cardSpace?: 'xl' | 'lg';
  cardWidth?: number;
  translations: {
    title: string;
    buttonText?: string;
  };
}

export const EpEmptyState = ({
  cardHeight = 'self',
  cardSpace = 'xl',
  cardWidth = 600,
  children,
  contentSpaceAvatarId,
  contentSpaceButtonId,
  contentSpaceButtonOnClickFunc,
  translations,
}: IEpEmptyState) => (
  <EpCard
    cardId="ep-card--with-content-space"
    cardElevation="one"
    cardSpace={cardSpace}
    cardHeaderIconName="solid-cube"
    card-has-close-button="true"
    cardBodyContentWidthType="contained"
    cardHeight={cardHeight}
    cardWidth={cardWidth}
  >
    <div slot="card-body-content">
      <EpContentSpace
        contentSpaceButtonId={contentSpaceButtonId}
        contentSpaceAvatarId={contentSpaceAvatarId}
        contentSpaceButtonOnClickFunc={contentSpaceButtonOnClickFunc}
        translations={translations}
      >
        {children}
      </EpContentSpace>
    </div>
  </EpCard>
);
